import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Renderer2 } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, OnDestroy {
  
  constructor(
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.renderer.setStyle(document.documentElement, 'background-color', '#0d0d0d');
    this.renderer.setStyle(document.body, 'background-color', '#0d0d0d');
  }

  ngOnDestroy() {
    this.renderer.removeStyle(document.documentElement, 'background-color');
    this.renderer.removeStyle(document.body, 'background-color');
  }
}
